import React, { useState } from "react";
import { Outlet , useLocation } from "react-router-dom";
import Header from "./../elements/Header";
// import Footer from "./../elements/Footer";
import { Context } from './../Auth.Context';


const Layout = () => {
	const location = useLocation();

	const adminDetail = localStorage.getItem("admin_details");
	const [adminDetails, setAdminDetails] = useState(adminDetail ? JSON.parse(adminDetail) : {});

	const noHeaderPaths = ["/login"];


	return (
		<Context.Provider value={[adminDetails, setAdminDetails]}>
			{!noHeaderPaths.includes(location.pathname) && <Header />}
			{/* <Header /> */}
			<Outlet />
			{/* <Footer /> */}
		</Context.Provider>
	)
};
export default Layout;